export const DEFAULT_ORG = 'org_intellesphere' as const;